import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'euroCurrency',
  standalone: true,
})
export class EuroCurrencyPipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    format = '1.0-0',
    ..._args: unknown[]
  ): string {
    return `${new CurrencyPipe('nl').transform(
      value,
      'EUR',
      'symbol',
      format
    )}`;
  }
}
